module.exports = __webpack_public_path__ + "img/SM.0ffe6242.png";